/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export type IntegrationCreditAllocationResponse = {
    validUntil: string | null;
    id: number;
    clientId: number;
    categoryId: number;
    totalCredits: number;
    usedCredits: number;
    source: IntegrationCreditAllocationResponse.source;
    isActive: boolean;
    note: string | null;
};
export namespace IntegrationCreditAllocationResponse {
    export enum source {
        PACKAGE = 'package',
        AGREEMENT = 'agreement',
        PRO_BONO = 'pro_bono',
        OTHER = 'other',
    }
}

